export default __webpack_public_path__ + "static/media/messages.b778d24a.svg";